import React, { useMemo, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { PARTICIPANT_ERROR_COUNTS_QUERY, PARTICIPANT_QUERY, USER_DETAILS } from '../graphQL/queries';
import { useQuery } from '@apollo/react-hooks';
import Customer from '../Customer';
import Provider from '../Provider';
import { Loading } from '../../Loading';
import moment from 'moment';

const ParticipantDetail = (props: any) => {
  const [userRole, setUserRole] = React.useState('');
  const history = useHistory();
  let code = history?.location?.pathname?.split('/');
  const { loading: userLoading, data: userData } = useQuery(USER_DETAILS, { fetchPolicy: 'cache-first' });

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
  }, [userData]);

  const { loading, data } = useQuery(PARTICIPANT_QUERY, {
    variables: {
      participantCode: code[2]
    }
  });

  const date = new Date();
  const todayDate = moment(date).format('YYYY-MM-DD');

  const [participantData, setParticipantData] = React.useState<any>({});

  const tDate = useMemo(() => {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const pDate = useMemo(() => {
    return new Date(date.getTime() - 1000 * 60 * 60 + date.getTimezoneOffset() * 60000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { loading: errorDayCountLoading, data: errorDayCountData } = useQuery(PARTICIPANT_ERROR_COUNTS_QUERY, {
    variables: {
      startDate: `${todayDate} 00:00:00`,
      endDate: `${todayDate} 23:59:59`,
      participantCode: code[2]?.toUpperCase()
    }
  });

  const { loading: errorHourCountLoading, data: errorHourCountData } = useQuery(PARTICIPANT_ERROR_COUNTS_QUERY, {
    variables: {
      startDate: moment(pDate).format('YYYY-MM-DD hh:mm:ss'),
      endDate: moment(tDate).format('YYYY-MM-DD hh:mm:ss'),
      participantCode: code[2]?.toUpperCase()
    }
  });

  React.useEffect(() => {
    let dataList = participantData;
    // console.log("🚀 ~ file: index.tsx ~ line 59 ~ React.useEffect ~ participantData", participantData)
    if (data?.participant) {
      dataList = data?.participant?.content?.[0];
    }
    if (errorDayCountData && data?.participant) {
      dataList.errorDayCountData = errorDayCountData;
    }
    if (errorHourCountData && data?.participant) {
      dataList.errorHourCountData = errorHourCountData;
    }
    setParticipantData(dataList);
    // console.log("🚀 ~ file: index.tsx ~ line 70 ~ React.useEffect ~ dataList", dataList)
  }, [data, errorDayCountData, errorHourCountData, participantData]);

  return (
    <Box>
      {loading || errorHourCountLoading || errorDayCountLoading || userLoading ? (
        <Loading />
      ) : data?.participant?.content?.[0]?.participantType === 'CUSTOMER' ? (
        <Customer data={participantData} userRole={userRole} participantCode={code[2]} />
      ) : (
        <Provider data={participantData} userRole={userRole} participantCode={code[2]} />
      )}
    </Box>
  );
};

export default ParticipantDetail;
